<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">全员人口信息管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          全员人口信息管理系统以建设省级全员人口基础数据库为核心，汇聚公安、卫生健康、医疗保障、民政、人力资源社会保障、教育等多源人口数据，建立统一的人口主索引与全生命周期档案，形成覆盖辖区内全部常住人口、流动人口的“一人一档、一户一档”数据底座，为人口动态监测、公共服务资源配置与宏观决策提供统一的数据支撑。
        </p>
        <p class="content-paragraph">
          系统围绕人口信息的“采、治、管、用”主线，提供多源数据接入与清洗比对、人口主索引（MPI）构建、家庭关系图谱与生命周期轨迹还原、跨部门数据共享交换等功能；面向业务提供出生死亡登记、迁移流动监测、人口结构与趋势分析、专题地图与报表等应用，推动人口治理由“条块分割”向“整体协同”转变，支撑政府提升人口服务与管理现代化水平。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">数据汇聚与治理</h3>
            <ul class="capability-list"><li>多源数据采集</li><li>人口主索引 MPI</li><li>数据清洗比对</li><li>质量校验规则</li><li>重复归并</li><li>增量更新</li><li>数据血缘追溯</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">人口档案管理</h3>
            <ul class="capability-list"><li>全员一人一档</li><li>家庭关系图谱</li><li>户籍与居住信息</li><li>婚育与健康状况</li><li>全生命周期轨迹</li><li>档案变更留痕</li><li>跨部门共享</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">监测分析与决策</h3>
            <ul class="capability-list"><li>人口总量与结构分析</li><li>流动迁移监测</li><li>出生死亡监测</li><li>老龄化趋势研判</li><li>专题地图展示</li><li>报表与导出</li><li>指标预警</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/rk-overview.svg"
              alt="海南华德科技有限公司 全员人口信息管理系统 - 人口档案总览 · 一人一档管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>人口档案总览 · 一人一档管理
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/rk-profile.svg"
              alt="海南华德科技有限公司 全员人口信息管理系统 - 人口档案详情 · 全生命周期视图"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>人口档案详情 · 全生命周期视图
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/rk-dashboard.svg"
              alt="海南华德科技有限公司 全员人口信息管理系统 - 人口监测大屏 · 多源数据融合"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>人口监测大屏 · 多源数据融合
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/rk-governance.svg"
              alt="海南华德科技有限公司 全员人口信息管理系统 - 数据治理 · 清洗比对与质量校验"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>数据治理 · 清洗比对与质量校验
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs1.vue